// export const IN_REVIEW = ["Start", "Not Selected", "Applied"];
// export const SHORTLISTED = ["Eligible", "Interview Scheduled", "Link Expired", "Interview Done", "Process Completed"];

export const IN_REVIEW = [
  "applied",
  "not selected",
  "start"
];

export const SHORTLISTED = [
  "eligible",
  "interview scheduled",
  "link expired",
  "interview done",
  "process completed",
];